<template>
    <div id="item-menu">
        <div class="header">
            {{ $t("form.formElements.formElements") }}
            <span class="md-icon" @click="$emit('close')">close</span>
        </div>
        <div class="content">
            <div
                class="item"
                v-for="item in items"
                :key="item.text"
                @dragstart="onDragStart(item)"
                :draggable="!isDisabled(item.id)"
                :class="{ disabled: isDisabled(item.id) }"
            >
                <div class="item-image">
                    <span class="md-icon">{{ item.icon }}</span>
                </div>
                <div class="item-text">{{ item.text }}</div>
            </div>
            <div class="title">{{ $t("form.basicElements.basicElements") }}</div>
            <div
                class="item"
                v-for="item in keyAreas"
                :key="item.text"
                @dragstart="onDragStart(item)"
                :draggable="!isDisabled(item.id)"
                :class="{ disabled: isDisabled(item.id) }"
            >
                <div class="item-image">
                    <span class="md-icon">{{ item.icon }}</span>
                </div>
                <div class="item-text">{{ item.text }}</div>
            </div>
            <div class="title">{{ $t("form.surveyElements.surveyElements") }}</div>
            <div
                class="item"
                v-for="item in surveyElements"
                :key="item.text"
                @dragstart="onDragStart(item)"
                :draggable="!isDisabled(item.id)"
                :class="{ disabled: isDisabled(item.id) }"
            >
                <div class="item-image">
                    <span class="md-icon">{{ item.icon }}</span>
                </div>
                <div class="item-text">{{ item.text }}</div>
            </div>
            <div class="title">{{ $t("form.pageElements.pageElements") }}</div>
            <div
                class="item"
                v-for="item in pageElements"
                :key="item.text"
                @dragstart="onDragStart(item)"
                :draggable="!isDisabled(item.id)"
                :class="{ disabled: isDisabled(item.id) }"
            >
                <div class="item-image">
                    <span class="md-icon">{{ item.icon }}</span>
                </div>
                <div class="item-text">{{ item.text }}</div>
            </div>
            <div style="margin-top: 100px"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ItemMenu",
    data() {
        return {
            items: [
                { id: "title", icon: "title", text: this.$t("form.formElements.title") },
                { id: "fullName", icon: "person", text: this.$t("form.formElements.fullName") },
                { id: "email", icon: "mail", text: this.$t("form.formElements.email") },
                { id: "address", icon: "pin_drop", text: this.$t("form.formElements.address") },
                { id: "phone", icon: "add_call", text: this.$t("form.formElements.phone") },
                { id: "datePicker", icon: "date_range", text: this.$t("form.formElements.datePicker") },
                // { id: "meeting", icon: "access_time", text: this.$t("form.formElements.appointment") },
                { id: "signature", icon: "edit", text: this.$t("form.formElements.signature") },
                { id: "captcha", icon: "security", text: "Captcha" },
                // { id: "listOfProducts", icon: "production_quantity_limits", text: this.$t("form.formElements.productList") },
            ],
            keyAreas: [
                { id: "shortText", icon: "edit_note", text: this.$t("form.basicElements.shortText") },
                { id: "longText", icon: "draw", text: this.$t("form.basicElements.longText") },
                { id: "paragraph", icon: "text_increase", text: this.$t("form.basicElements.paragraph") },
                { id: "dropDownList", icon: "low_priority", text: this.$t("form.basicElements.dropDownList") },
                { id: "singleChoice", icon: "radio_button_checked", text: this.$t("form.basicElements.singleChoice") },
                { id: "multipleSelection", icon: "checklist", text: this.$t("form.basicElements.multipleSelection") },
                { id: "number", icon: "filter_7", text: this.$t("form.basicElements.number") },
                { id: "image", icon: "image", text: this.$t("form.basicElements.image") },
                { id: "fileUpload", icon: "drive_folder_upload", text: this.$t("form.basicElements.fileUpload") },
                { id: "hour", icon: "timer", text: this.$t("form.basicElements.hour") },
                { id: "spinner", icon: "join_left", text: this.$t("form.basicElements.spinner") },
                { id: "send", icon: "send", text: this.$t("form.basicElements.send") },
            ],
            surveyElements: [
                // { id: "dataTable", icon: "calculate", text: this.$t("form.surveyElements.dataTable") },
                { id: "starRating", icon: "star", text: this.$t("form.surveyElements.starRating") },
                { id: "ratingScale", icon: "bar_chart", text: this.$t("form.surveyElements.evaluationScale") },
            ],
            pageElements: [
                {
                    id: "separationElement",
                    icon: "safety_divider",
                    text: this.$t("form.pageElements.separationElement"),
                },
                { id: "pagebreak", icon: "more_horiz", text: "Sayfa Sonu" },
                // { id: "collapseSection", icon: "expand", text: this.$t("form.pageElements.partitionCollapse") },
                //{ id: "pageBreak", icon: "insert_page_break", text: this.$t("form.pageElements.pageBreak") },
            ],
            draggedItem: null,
        };
    },
    methods: {
        onDragStart(item) {
            if (this.isDisabled(item.id)) {
                this.$message.warning(`${item.text} Elemanı Yapım Aşamasındadır.`);
            } else {
                this.draggedItem = item;
                event.dataTransfer.setData("item", JSON.stringify(item));
            }
        },
        isDisabled(itemId) {
            const disabledItems = [
                "meeting",
                //"signature",
                "listOfProducts",
                //"paragraph",
                // "image",
                "dataTable",
                "collapseSection",
                "pageBreak",
                // "singleChoice",
                // "multipleSelection",
            ];
            return disabledItems.includes(itemId);
        },
    },
};
</script>

<style lang="scss" scoped>
#item-menu {
    width: 260px;
    background-color: #fff;
    border: 1px solid #e9edf3;
    box-shadow: 0 10px 30px rgba(21, 25, 36, 0.12);
    border-top-right-radius: 12px;
    overflow: hidden;
    font-family: "Roboto", sans-serif;

    .header {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 16px 16px 18px 16px;
        background: linear-gradient(135deg, #f26a52 0%, #e55a42 100%);
        color: #ffffff;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        border-top-right-radius: 12px;
        font-weight: 600;
        font-size: 1.05rem;
        line-height: 1.15;

        .md-icon {
            position: absolute;
            right: 12px;
            top: 12px;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.1rem;
            cursor: pointer;
            color: #ffffff;
            background: rgba(255, 255, 255, 0.16);
            border-radius: 50%;
            transition: background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;

            &:hover {
                background: rgba(255, 255, 255, 0.22);
                transform: scale(1.04);
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
            }
        }
    }

    .content {
        max-height: 100%;
        overflow-y: auto;
        padding: 8px 8px 100px 8px;

        .title {
            padding: 10px 12px;
            margin: 8px 8px 6px 8px;
            background-color: #f5f7fa;
            color: #2c3e50;
            font-weight: 600;
            font-size: 0.85rem;
            border-radius: 8px;
            letter-spacing: 0.2px;
        }

        .item {
            display: flex;
            align-items: center;
            padding: 10px 12px;
            margin: 6px 8px;
            border: 1px solid #eef1f5;
            border-radius: 10px;
            background: #ffffff;
            transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
            cursor: pointer;

            &:hover {
                background-color: #f8faff;
                border-color: #c7d2fe;
                box-shadow: 0 6px 16px rgba(102, 126, 234, 0.15);
                transform: translateX(2px);
            }

            &.disabled {
                opacity: 0.5;
                pointer-events: none;
            }

            .item-image {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                height: 40px;
                font-size: 1.4rem;
                color: #ffffff;
                margin-right: 12px;
                border-radius: 10px;
                box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.04);
            }

        }

        // İkon renkli arka planları
        .item:nth-child(1) .item-image { background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); }
        .item:nth-child(2) .item-image { background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%); }
        .item:nth-child(3) .item-image { background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); }
        .item:nth-child(4) .item-image { background: linear-gradient(135deg, #059669 0%, #047857 100%); }
        .item:nth-child(5) .item-image { background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%); }
        .item:nth-child(6) .item-image { background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%); }
        .item:nth-child(7) .item-image { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); }
        .item:nth-child(8) .item-image { background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%); }
        .item:nth-child(9) .item-image { background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); }
        .item:nth-child(10) .item-image { background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%); }
        .item:nth-child(11) .item-image { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
        .item:nth-child(12) .item-image { background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%); }
        .item:nth-child(13) .item-image { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); }
        .item:nth-child(14) .item-image { background: linear-gradient(135deg, #ec4899 0%, #db2777 100%); }
        .item:nth-child(15) .item-image { background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%); }
        .item:nth-child(16) .item-image { background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%); }
        .item:nth-child(17) .item-image { background: linear-gradient(135deg, #84cc16 0%, #65a30d 100%); }
        .item:nth-child(18) .item-image { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
        .item:nth-child(19) .item-image { background: linear-gradient(135deg, #eab308 0%, #ca8a04 100%); }
        .item:nth-child(20) .item-image { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); }
        .item:nth-child(21) .item-image { background: linear-gradient(135deg, #64748b 0%, #475569 100%); }
        .item:nth-child(22) .item-image { background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%); }
        .item:nth-child(23) .item-image { background: linear-gradient(135deg, #f97316 0%, #ea580c 100%); }
        .item:nth-child(24) .item-image { background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); }
        .item:nth-child(25) .item-image { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
        .item:nth-child(26) .item-image { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); }
        .item:nth-child(27) .item-image { background: linear-gradient(135deg, #ec4899 0%, #db2777 100%); }

        .item-text {
            flex: 1;
            font-size: 0.98rem;
            color: #2b2f3a;
            font-weight: 500;
        }
    }
}
</style>
